export default __webpack_public_path__ + "static/media/surgical_sterilization_default.0c5dd32b.svg";